module.exports = __webpack_public_path__ + "static/media/14UNEP21.8f9a2eee.jpg";